<template>
  <span
    v-if="resolvedUrl && variant === 'icon'"
    class="ad-display-preview-btn-wrap"
    tabindex="0"
    aria-describedby="tips-open-display-icon"
  >
    <a
      class="ad-display-preview-btn ad-display-preview-btn--icon"
      :href="resolvedUrl"
      target="_blank"
      rel="noopener noreferrer"
      :title="$t('lbl_EMPBE_AdDetail_OpenDisplay')"
      :t-label="resolvedTLabel"
    >
      <i class="fa fa-external-link ad-display-preview-btn__icon-only" aria-hidden="true"></i>
    </a>
    <div
      id="tips-open-display-icon"
      class="tips-pop"
      role="tooltip"
      aria-live="polite"
    >
      <div class="tips-box">
        <i class="tips-arrow" aria-hidden="true"></i>
        <h4 class="tips-title">{{ $t("lbl_EMPBE_AdDetail_OpenDisplayTip") }}</h4>
      </div>
    </div>
  </span>
  <a
    v-else-if="resolvedUrl"
    class="ad-display-preview-btn"
    :class="`ad-display-preview-btn--${variant}`"
    :href="resolvedUrl"
    target="_blank"
    rel="noopener noreferrer"
    :t-label="resolvedTLabel"
  >
    <span class="ad-display-preview-btn__label">{{ $t('lbl_EMPBE_AdDetail_OpenDisplay') }}</span>
    <i class="fa fa-external-link ad-display-preview-btn__icon" aria-hidden="true"></i>
  </a>
</template>

<script>
import { buildAdInfoCenterTLabel, resolveAdInfoCenterTrackingRoleId } from './adDisplayConfig';

export default {
  name: 'AdDisplayPreviewButton',
  props: {
    url: { type: String, default: '' },
    tLabel: { type: String, default: '' },
    variant: {
      type: String,
      default: 'icon',
      validator: (value) => ['icon', 'link'].includes(value),
    },
  },
  computed: {
    resolvedUrl() {
      return (this.url || '').trim();
    },
    resolvedTLabel() {
      if (this.tLabel) return this.tLabel;
      const user = this.$store.state.authentication.user;
      return buildAdInfoCenterTLabel(
        'Detail',
        'btnOpenDisplay',
        user?.empCompanyId,
        resolveAdInfoCenterTrackingRoleId(this.$store)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-display-preview-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-decoration: none;
  cursor: pointer;
}

.ad-display-preview-btn-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.ad-display-preview-btn--link {
  gap: 4px;
  padding: 8px;
  border-radius: 4px;
  color: #7366ff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;

  &:hover {
    background: rgba(115, 102, 255, 0.08);
    text-decoration: none;
    color: #7366ff;
  }
}

.ad-display-preview-btn--icon {
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  color: #7366ff;
  font-size: 16px;
  line-height: 1;
  background: #fff;

  .ad-display-preview-btn__icon-only {
    display: block;
    width: 16px;
    height: 16px;
    margin: 0;
    line-height: 1;
    font-size: 16px;
    transform: translateY(1px);

    &::before {
      display: block;
      line-height: 1;
    }
  }

  &:hover {
    border-color: rgba(115, 102, 255, 0.45);
    background: rgba(115, 102, 255, 0.04);
    color: #7366ff;
    text-decoration: none;
  }
}

.tips-pop {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  transform: translateY(-2px);
  opacity: 0;
  pointer-events: none;
  z-index: 3000;
  transition: opacity 0.12s ease, transform 0.12s ease;
}

.ad-display-preview-btn-wrap:hover .tips-pop,
.ad-display-preview-btn-wrap:focus .tips-pop,
.ad-display-preview-btn-wrap:focus-within .tips-pop {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.tips-box {
  position: relative;
  max-width: 420px;
  min-width: 260px;
  padding: 10px 14px;
  border-radius: 8px;
  background: linear-gradient(180deg, #6b50f0 0%, #5a46e6 100%);
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  text-align: left;
}

.tips-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #fff;
  white-space: normal;
}

.tips-arrow {
  position: absolute;
  top: -6px;
  right: 16px;
  width: 12px;
  height: 12px;
  background: #6b50f0;
  transform: rotate(45deg);
  border-radius: 2px;
}
</style>
